import React, { useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import StatsBar from "./components/StatsBar";
import HowItWorks from "./components/HowItWorks";
import RideOptions from "./components/RideOptions";
import Features from "./components/Features";
import WaitlistBanner from "./components/WaitlistBanner";
import DriverSection from "./components/DriverSection";
import EarningsCalculator from "./components/EarningsCalculator";
import Cities from "./components/Cities";
import SignUp from "./components/SignUp";
import Testimonials from "./components/Testimonials";
import Faq from "./components/Faq";
import DownloadCTA from "./components/DownloadCTA";
import Footer from "./components/Footer";
import WaitlistModal from "./components/WaitlistModal";
import VideoModal from "./components/VideoModal";
import AppPage from "./pages/AppPage";
import AdminPage from "./pages/AdminPage";
import { Toaster } from "./components/ui/sonner";

function Landing() {
  const [waitlist, setWaitlist] = useState(false);
  const [video, setVideo] = useState(false);
  const openWaitlist = () => setWaitlist(true);

  return (
    <div className="App min-h-screen bg-[#07090a]">
      <Navbar onWaitlist={openWaitlist} />
      <main>
        <Hero onWaitlist={openWaitlist} onVideo={() => setVideo(true)} />
        <Marquee />
        <StatsBar />
        <HowItWorks />
        <RideOptions onWaitlist={openWaitlist} />
        <Features />
        <WaitlistBanner onWaitlist={openWaitlist} />
        <DriverSection />
        <EarningsCalculator />
        <Cities />
        <SignUp />
        <Testimonials />
        <DownloadCTA onWaitlist={openWaitlist} />
        <Faq />
      </main>
      <Footer />

      <WaitlistModal open={waitlist} onOpenChange={setWaitlist} />
      <VideoModal open={video} onOpenChange={setVideo} />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/app" element={<AppPage />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
      <Toaster position="bottom-center" theme="dark" richColors />
    </BrowserRouter>
  );
}

export default App;
